/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Amendment_Link_CreatedInputs */

const en_orders_amendment_link_created = /** @type {(inputs: Orders_Amendment_Link_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Created`)
};

const es_orders_amendment_link_created = /** @type {(inputs: Orders_Amendment_Link_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link creado`)
};

/**
* | output |
* | --- |
* | "Link Created" |
*
* @param {Orders_Amendment_Link_CreatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_amendment_link_created = /** @type {((inputs?: Orders_Amendment_Link_CreatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Amendment_Link_CreatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_amendment_link_created(inputs)
	return es_orders_amendment_link_created(inputs)
});